<script setup>
import { reactive } from 'vue'
import MenuLayout from '../layout/MenuLayout.vue'
import { useMetaStore } from '@/stores'
import { postMultipart, validators } from '@/common/util'
import _ from 'lodash-es'
import config from '@/common/config'
const metaStore=useMetaStore(),meta=reactive({pd:{category:'roadview_inquery',stat:'wait'}
    ,cols:[{tk:'companyperiodname',nm:'company',required:true},{tk:'name',nm:'nm',required:true},{tk:'email',nm:'email',required:true}
      ,{tk:'contact',nm:'contact',required:true},{tk:'desiredregion',nm:'tarloc',required:true},{tk:'title',nm:'ttl',required:true},{tk:'contents',nm:'cont',required:true}]})
,newInquery=async()=>{
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/member/newinquery',meta.pd)
  metaStore.blockLoading(false)
  if(!res.isSuccess)return metaStore.toastRslt(res,true)
  metaStore.dialog({shown:true,ttl:'inquery_completed',cont:'inquery_received',istk:true,showcancel:false})
}
</script>
<template>
  <MenuLayout>
    <v-card class="w-100 h-100 overflow-auto" flat>
      <v-card-title class="font-weight-black">
        <v-breadcrumbs :items="['roadview_shootinginquiry']">
          <template #item="{item}">{{ $t(item.title) }}</template>
        </v-breadcrumbs>
      </v-card-title>
      <v-card-text>
        <div :style="`background-color: aqua;width: 1000px;height: 800px;background-image:url(${config.frontRoot}roadview.jpg);`">
          <div style="margin: auto;text-align: center;color: red;">
            <div>거리뷰 촬영이 필요하신가요?</div>

            <div>업계 최고의 전문과들과 상의하세요</div>

            <div>어떠한 문의라도 환영합니다</div>
            <div><v-btn color="primary" :text="$t('contactus')" @click="meta.poptype=null;metaStore.pop({ison:true,callback:()=>meta.poptype='newinquery'})"/></div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </MenuLayout>
  <Teleport v-if="meta.poptype=='newinquery'" to="#popbody">
    <v-card min-width="500">
      <v-card-title>{{$t('roadview_shootinginquiry')}}</v-card-title>
      <v-divider/>
      <v-card-text>
          <v-row v-for="col in meta.cols" no-gutters>
            <v-col>
              <v-text-field class="mt-2" variant="outlined" density="compact" v-if="col.nm!='cont'" :label="$t(col.tk)+(col.required?'*':'')" v-model="meta.pd[col.nm]" :rules="[col.required?validators.required:true]"/>
              <v-textarea class="mt-2" variant="outlined" density="compact" v-else :label="$t(col.tk)+(col.required?'*':'')" v-model="meta.pd[col.nm]" :rules="[col.required?validators.required:true]"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div>{{ $t('privacyconsent') }}</div>
              <div><v-checkbox hide-details density="compact" :label="`(${$t('mandatory')}) ${$t('privacyconsentok')}`" v-model="meta.agree1"/></div>
              <div><v-checkbox hide-details density="compact" :label="`(${$t('mandatory')}) ${$t('consentForProvidingPersonalInformationToThirdParties')}`" v-model="meta.agree2"/></div>
            </v-col>
          </v-row>
        </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="$t('cancel')" variant="elevated" @click="metaStore.pop({ison:false})"/>
        <v-btn :text="$t('save')" variant="elevated" color="primary"
          :disabled="!meta.cols.filter(col=>col.required).map(col=>meta.pd[col.nm]).every(val=>!_.isEmpty(val))||!meta.agree1||!meta.agree2" @click="newInquery"/>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
